import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { FvmsApiBaseService } from "./fvms.api.base.service";
import { deprecate } from 'util';

@Injectable({providedIn: 'root'})
export class FvmsApiDtgDashboardService extends FvmsApiBaseService {
    constructor(
        public http:HttpClient
    ) {
        super(http);
    }

    getCarCountAll(companyId:any,dtgTeamId:any,dtgEid:string):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/dashboard";
        url += "/top/car/count/all";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpSearchInfo = {
            "companyId":companyId
            ,"dtgTeamId":dtgTeamId
            ,"dtgEid":dtgEid
        };
        let tmpPostObject = {
            "searchInfo":tmpSearchInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    //Deprecated
    // getCarUseCount(searchInfo:any):Observable<any>{
    //     let url = this.getApiBaseUrl() + "/dtg/dashboard";
    //     url += "/top/car/use/count";

    //     let header = new HttpHeaders({
    //         "Content-Type":"application/json"
    //     });

    //     // searchInfo = {
    //     //     companyId:1
    //     //     ,dtgTeamId:0
    //     //     ,searchDateFrom:"2019-04-06 00:00:00"
    //     //     ,searchDateTo:"2019-04-06 23:59:59"
    //     //     ,dtgGroupByRegDtYy:"Y"//년도별 동시운행차량수
    //     //     ,dtgGroupByRegDtMm:"Y"//월별 동시운행차량수
    //     //     ,dtgGroupByRegDtDd:"Y"//일별 동시운행차량수
    //     // };
    //     let tmpPostObject = {
    //         "searchInfo":searchInfo
    //     };

    //     //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
    //     //때문에 객체를 복사해서 사용
    //     let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

    //     let bodyData = JSON.stringify(tmpData);

    //     return this.http.post<any>(url,bodyData,{ headers : header });
    // }

    //Deprecated
    // getCarUseTop(searchInfo:any):Observable<any>{
    //     let url = this.getApiBaseUrl() + "/dtg/dashboard";
    //     url += "/top/car/use/top";

    //     let header = new HttpHeaders({
    //         "Content-Type":"application/json"
    //     });

    //     // searchInfo = {
    //     //     companyId:1
    //     //     ,dtgTeamId:0
    //     //     ,searchDateFrom:"2019-04-06 00:00:00"
    //     //     ,searchDateTo:"2019-04-06 23:59:59"
    //     //     ,limitCnt:3
    //     // };
    //     let tmpPostObject = {
    //         "searchInfo":searchInfo
    //     };

    //     //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
    //     //때문에 객체를 복사해서 사용
    //     let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

    //     let bodyData = JSON.stringify(tmpData);

    //     return this.http.post<any>(url,bodyData,{ headers : header });
    // }

    //Deprecated
    // getDashboardData(searchInfo:any){ 
    //     let url = this.getApiBaseUrl() + "/dtg/dashboard";
    //     url += "/data";

    //     let header = new HttpHeaders({
    //         "Content-Type":"application/json"
    //     });

    //     let tmpPostObject = {
    //         "searchInfo":searchInfo
    //     };

    //     //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
    //     //때문에 객체를 복사해서 사용
    //     let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

    //     let bodyData = JSON.stringify(tmpData);

    //     return this.http.post<any>(url,bodyData,{ headers : header });
    // }
}